// @ts-nocheck
/**
 * 属性補正テーブル
 * 速度・防御の固定ステータスに影響
 * @module twinKey/core/party/data/attributeModifiers
 */

export const ATTRIBUTE_MODIFIERS = {
  '炎':   { speed: 15, defense: 0,  description: '短期決戦型' },
  '水':   { speed: -5, defense: 30, description: '耐久型' },
  '光':   { speed: 5,  defense: 5,  description: 'バランス型' },
  '闇':   { speed: 0,  defense: 10, description: 'トリッキー型' },
  '未来': { speed: 10, defense: 0,  description: '攻守中庸' },
  '原始': { speed: -15, defense: 60, description: '大味/生命力' },
  'なし': { speed: 0,  defense: 10, description: '癖なし' },
};

/**
 * 属性補正を取得
 * @param {string} attribute - 属性
 * @returns {{ speed: number, defense: number }}
 */
export function getAttributeModifier(attribute) {
  return ATTRIBUTE_MODIFIERS[attribute] || ATTRIBUTE_MODIFIERS['なし'];
}
